import React from 'react';

const LOCATION_STATUS = {
    1: { label: 'Active',     cls: 'badge-success' },
    3: { label: 'Suspended',  cls: 'badge-warning' },
    4: { label: 'Eliminated', cls: 'badge-danger' },
};

const Field = ({ label, children }) => (
    <div className="mb-3">
        <div className="text-muted small font-weight-bold">{label}</div>
        <div>{children}</div>
    </div>
);

export const CreateNewProgramRequestView = ({ requestDetails }) => {
    const {
        programName,
        cipCode,
        cipTitle,
        degreeLevel,
        deliveryMode,
        deliveryModeOnline,
        creditRequirementMinimum,
        creditRequirementMaximum,
        locations,
        additionalComments,
    } = requestDetails;

    const showOnlineNature = deliveryMode && deliveryMode !== 'On Campus Only';
    const hasCredits = creditRequirementMinimum || creditRequirementMaximum;

    return (
        <div className="request-type-details">
            <h5 className="mb-1">New Program Request Details</h5>
            <hr className="mt-2 mb-3" />

            <Field label="Program Name">
                {programName || <span className="text-muted">—</span>}
            </Field>

            <Field label="CIP Code">
                {cipCode
                    ? <>{cipCode}{cipTitle ? <> &mdash; {cipTitle}</> : null}</>
                    : <span className="text-muted">—</span>}
            </Field>

            <Field label="Degree / Award Level">
                {degreeLevel || <span className="text-muted">—</span>}
            </Field>

            <Field label="Delivery Mode">
                {deliveryMode || <span className="text-muted">—</span>}
            </Field>

            {showOnlineNature && (
                <Field label="Nature of Online Program">
                    {deliveryModeOnline || <span className="text-muted">—</span>}
                </Field>
            )}

            <Field label="Credit Hours">
                {hasCredits
                    ? <>Min: {creditRequirementMinimum ?? '—'} &nbsp;&nbsp; Max: {creditRequirementMaximum ?? '—'}</>
                    : <span className="text-muted">—</span>}
            </Field>

            <Field label="Locations">
                {locations?.length > 0 ? (
                    <ul className="list-unstyled mb-0">
                        {locations.map(loc => {
                            const status = LOCATION_STATUS[loc.statusId] ?? { label: 'Unknown', cls: 'badge-secondary' };
                            return (
                                <li key={loc.locationId} className="mb-1">
                                    {loc.locationName}{' '}
                                    <span className={`badge ${status.cls}`}>{status.label}</span>
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <span className="text-muted">—</span>
                )}
            </Field>

            {additionalComments && (
                <Field label="Comments">
                    {additionalComments}
                </Field>
            )}
        </div>
    );
};
